import Axios, { CancelTokenSource } from 'axios';
import React, { useEffect, useState } from 'react';
import AxiosHelper from 'services/AxiosHelper';
import Spinner from 'shared/components/Spinner';

interface WysiwygResponse {
	name: string | null;
	code: string | null;
	content: string | null;
}

interface WysiwygProps {
	code: string | null;
}

export default function Wysiwyg(props: WysiwygProps) {
	const [content, setContent] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const getContent = async () => {
		setIsLoading(true);
		const requestToken: CancelTokenSource = Axios.CancelToken.source();

		try {
			const result = await AxiosHelper.post<WysiwygResponse>('/ajax/wysiwyg', {
				code: props.code,
				cancelToken: requestToken.token,
			});

			setContent(result.data?.content);
		} catch (error) {
			if (Axios.isCancel(error)) {
				// if the component was unmounted, there's nothing to do
				setIsLoading(false);
				return;
			}
		}
		setIsLoading(false);
		return;
	};

	useEffect(() => {
		getContent();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{isLoading ? <Spinner /> : null}
			{content ? <div dangerouslySetInnerHTML={{ __html: content }} /> : null}
		</>
	);
}
